// Framework
import { Component, Output, EventEmitter } from '@angular/core';
// ngx-bootstrap
import { BsModalRef } from 'ngx-bootstrap/modal';
// Services
import { DataService } from '../../services/data.service';

@Component({
    selector: 'privacy-policy-modal',
    templateUrl: './privacy-policy-modal.component.html'
})

export class PrivacyPolicyModalComponent {

    constructor (
        private dataSvc: DataService,
        public bsModalRef: BsModalRef
    ) {
    }

    dismissModal() {
        this.bsModalRef.hide();
    }
}